import ApiService from '@/common/api/api.service';

let apiBasePath = 'PeriodoContabil';
const BalanceteService = {
    // FUNÇÕES DE BUSCA:
    async obterBalancetePaginado(parametros) {
        let { data } = await ApiService.get(`${apiBasePath}/listar-balancete-paginado`, { params: {...parametros}});
        return data;
    },

    // Relatorios
    async gerarRelatorioBalancete(filtro) {
        let { data } = await ApiService.get(`${apiBasePath}/relatorio-contabil/balancete`, {
            params: {
                ...filtro,
            }
        });
        return data;
    },

    async gerarRelatorioBalanceteExcel(filtro) {
        let { data } = await ApiService.get(`${apiBasePath}/relatorio-contabil/balancete-excel`, {
            params: {
                ...filtro,
            }
        });
        return data;
    },

};

export default BalanceteService;
